import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DupontButton from "../components/DupontButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { uploadSelectedFile, uploadSelectedSheet } from "../network/cipAPI";
import XLSFileDownload from "../XLSDownload";
import { CircularProgress } from "@mui/material";
import createNotification, {
  SUCCESS_NOTIFICATION,
} from "../components/Notifications";
import { cleanData } from "../Store/TemplateStore/template.action";
import { useTranslation } from "react-i18next";
import DupontDialog from "../components/DupontDialog";
import { storeFileId } from "../Store/TemplateStore/template.action";

const PerformanceData = React.forwardRef(
  (
    {
      setFileId,
      fileId,
      fileInfo,
      selectedTrain,
      setSheetNames,
      setFileInfo,
      setColumnsOptions,
      setMappedReference,
      setMappedColumn,
      setSelectedTrain,
      setSelectedCIPFileName,
      setHasRecurrentCIPs,
      setDisableTrain,
      setSelectedSheet,
    },
    ref
  ) => {
    const { t } = useTranslation();

    const performanceData = async () => {
      if (!fileId) {
        setError(t("ValueStrings.validFile"));
        return;
      }
    };

    React.useImperativeHandle(ref, () => ({ performanceData }));
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isFileLoading, setIsFileLoading] = useState(false);
    const [fileName, setFileName] = useState(fileInfo?.fileName);
    const [dialogopen, setDialogOpen] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
      setFileName(fileInfo.fileName);
      if (fileInfo && fileInfo.fileName && setDisableTrain) {
        setDisableTrain(false);
      }
    }, [fileInfo, setDisableTrain]);

    const uploadFile = async (file) => {
      setIsLoading(true);
      try {
        if (!isLoading) {
          const chunkSize = 3 * 1024 * 1024; // 3MB per chunk
          const totalChunks = Math.ceil(file.size / chunkSize);
          const fileName = file.name;

          var promise_list = [];
          for (let i = 0; i < totalChunks - 1; i++) {
            const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);
            const formData = new FormData();
            formData.append("File", chunk, fileName);
            promise_list.push(
              uploadSelectedFile(
                formData,
                i + 1,
                totalChunks,
                selectedTrain,
                false
              )
            );
            // const response = axios.post('http://127.0.0.1:5001/api/v1/plants/159/uploadfile?chunkIndex='+(i+1)+'&totalChunks='+totalChunks, formData, {
            //    headers: {'Content-Type': 'multipart/form-data','sso_email_id':'sovit.mittal@dupont.com'}
            //  });
            //  promise_list.push(response);
          }

          await Promise.all(promise_list);

          // for the last chunk
          const chunk = file.slice(
            (totalChunks - 1) * chunkSize,
            totalChunks * chunkSize
          );
          const formData = new FormData();
          formData.append("File", chunk, fileName);
          // const response1 =await axios.post('http://127.0.0.1:5001/api/v1/plants/159/uploadfile?chunkIndex='+totalChunks+'&totalChunks='+totalChunks, formData, {
          //   headers: {'Content-Type': 'multipart/form-data','sso_email_id':'sovit.mittal@dupont.com'}
          // });
          // const response = response1.data;
          const LastApiCallResponse = await uploadSelectedFile(
            formData,
            totalChunks,
            totalChunks,
            selectedTrain,
            false
          );
          const response = await uploadSelectedFile(
            formData,
            totalChunks,
            totalChunks,
            selectedTrain,
            true
          );

          if (response && response.file_id === 0) {
          } else if (response) {
            setIsFileLoading(false);
            const resposnseSheetNames = response.sheet_names;
            setSheetNames(resposnseSheetNames);
            const fileInfo1 = {
              fileName: response.file_name,
            };
            setFileInfo(fileInfo1);
            dispatch(storeFileId(fileInfo1));

            createNotification(
              SUCCESS_NOTIFICATION,
              t("notificationStrings.fileSuccess"),
              ""
            );
            dispatch({
              type: "STORE_FILE_ID",
              payload: {
                fileName: encodeURIComponent(file.name),
              },
            });
            if (response.sheet_names?.length > 1) {
              setDialogOpen(true);
            } else if (response.sheet_names?.length === 1) {
              const responseSheet = await uploadSelectedSheet(
                selectedTrain,
                encodeURIComponent(file.name),
                resposnseSheetNames[0]
              );
              setColumnsOptions(responseSheet?.cols);
              setFileId(responseSheet?.file_id);
              dispatch({
                type: "STORE_FILE_ID",
                payload: {
                  file_id: responseSheet?.file_id,
                },
              });
            }
          } else {
            setError(response?.detail.error);
          }
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
        setIsFileLoading(false);
      }
    };

    const handleFileUpload = (e) => {
      setError(null);
      const uploadedFile = e.target.files[0];
      if (uploadedFile) {
        setIsFileLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
          setFile(uploadedFile);
          uploadFile(uploadedFile);
        };
        reader.readAsBinaryString(uploadedFile);
      }
    };

    const handleAddFileClick = () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    };

    const handleCloseClick = () => {
      inputRef.current.value = "";
      dispatch(cleanData());
      setFile(null);
      setError(null);
      setFileId(null);
      setFileName(null);
      setSheetNames(null);
      setColumnsOptions(null);
      setMappedReference(null);
      setMappedColumn(null);
      setDisableTrain(true);
      setSelectedSheet(null);
      setSelectedCIPFileName(null);
      setHasRecurrentCIPs(false);
      setSelectedTrain(1);
      dispatch({
        type: "STORE_FILE_ID",
        payload: {
          file_id: null,
          fileName: null,
        },
      });
    };
    const onCloseClicked = async (value) => {
      setDialogOpen(false);
    };

    return (
      <div className="lightGrayBorder" style={{ padding: "10px" }}>
        <div className="box-title  flex-between-center">
          {t("ValueStrings.selectFileToUpload")}
          <XLSFileDownload />
        </div>
        <input
          ref={inputRef}
          type="file"
          onChange={handleFileUpload}
          accept=".xlsx, .xls, .csv"
          style={{ display: "none" }}
        />

        <div className="note">{t("ValueStrings.uploadFileNote")} </div>

        <div style={{ display: "flex" }}>
          <DupontButton
            type="tertiary"
            onClick={handleAddFileClick}
            disabled={file || fileName}
            customClass="d-flex add-button "
          >
            {t("ValueStrings.addFile")}
            <span style={{ marginLeft: "10px", marginTop: "-1px" }}>
              <AddIcon fontSize="small" />
            </span>
          </DupontButton>
          {(file || fileName) && (
            <div className="selected-file">
              {file?.name || fileName}
              {isLoading || isFileLoading ? (
                <CircularProgress
                  size="20px"
                  thickness={5}
                  className="close-icon"
                  style={{ position: "right", color: "teal" }}
                />
              ) : (
                <CloseIcon onClick={handleCloseClick} className="close-icon" />
              )}
            </div>
          )}
          {dialogopen && (
            <DupontDialog
              open={dialogopen}
              title={t("ValueStrings.excelProcessing")}
              cancelBtnText={"OK"}
              onClose={onCloseClicked}
              minWidth={575}
            >
              <div
                className="lightGrayBorder optionalDescriptionText"
                style={{ padding: "14px" }}
              >
                <span>{t("ValueStrings.multiSheetMessage")}</span>
                <span>{t("ValueStrings.multiFileMessage")}</span>
              </div>
            </DupontDialog>
          )}
        </div>
        {error && <div className="errorMsg marginTop10">{error}</div>}
      </div>
    );
  }
);

export default PerformanceData;
